import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import CircularProgress from 'material-ui/CircularProgress';
import styles from 'styles';

import { getStatisticsUsers } from 'actions/statistics/users';

import Table from './Table/Table';
import RangeDates from './RangeDates';
import RegistrationsCharts from './RegistrationsCharts';

class StatisticsUsersPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            from: moment().startOf('day').add(-1, 'month').toDate(),
            until: moment().startOf('day').toDate(),
        };

        this.changeDateRange = this.changeDateRange.bind(this);
    }

    changeDateRange(from, until) {
        this.setState({
            from,
            until,
        });
    }

    UNSAFE_componentWillMount() {
        const { from, until } = this.state;

        this.props.getStatisticsUsers(
            moment(from).utcOffset(0, true).valueOf(),
            moment(until).utcOffset(0, true).valueOf(),
        );
    }

    render() {
        const { from, until } = this.state;
        const { isLoaded } = this.props;

        return (
            <div id='statistics-users' className='container'>
                <h3>Statistics users</h3>
                {isLoaded ?
                    <div>
                        <RegistrationsCharts from={from} until={until} />
                        <RangeDates from={from} until={until} changeDateRange={this.changeDateRange} />
                        <Table />
                    </div>
                    :
                    <CircularProgress
                        style={styles.circularProgress}
                    />
                }
            </div>
        );
    }
}

export default connect(
    ({ user: { isLogged }, statisticsUsers }) => {
        return {
            isLogged,
            isLoaded: statisticsUsers.isLoaded
        };
    },
    dispatch => bindActionCreators({
            getStatisticsUsers
    },
    dispatch),
)(StatisticsUsersPage);



// WEBPACK FOOTER //
// ./app/components/Statistics/Users/Page.jsx